import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import SelectRedux from "components/molecules/SelectRedux";
import { bookingActions } from "redux/slices/booking";
import { digitFixer } from "utils/digitfixer.util";
import {
  getBookingPaymentGateway,
  isStripeBooking,
} from "utils/paymentGateway.util";


export default function SelectRole(props: any) {
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking.booking);
  const [refundOptions, setRefundOptions] = useState<any[]>([])

  useEffect(() => {
    if (!booking) return
    const fullTripPrice = digitFixer(
      (booking.price_details.brutto_price || 0) +
      (booking.price_details?.tanfeethi?.price || 0) +
      (booking.price_details?.al_masar?.price || 0)
    );
    const gateway = getBookingPaymentGateway(booking);
    let options: any[] = [];

    if (booking.user_id || booking.is_guest_checkout) {
      const paymentIntent = isStripeBooking(booking)
        ? booking?.stripe_payment_detail?.payment_intent || booking.payment_intent
        : booking.payment_intent;

      if (paymentIntent) {
        options.push({
          value: paymentIntent,
          label: `booking price-${fullTripPrice} || refunded price-${booking.price_details.refunded_price}`,
          data: {
            trip: "original",
            price: fullTripPrice,
            refundedPrice: booking.price_details.refunded_price,
            gateway,
          },
        });
      }
    }

    if (!booking.is_kiosk && booking.extend_ids && booking.extend_ids.length > 0) {
      for (const extend of booking.extend_ids) {
        options.push({ value: extend.payment_intent, label: `extension price-${extend.price} || refunded price-${extend.refunded_price}`, data: { trip: "extension", extend_id: extend._id, price: extend.price, merchant_ref: extend.merchant_ref, paidBy: extend.payment_method, refundedPrice: extend.refunded_price } })
      }
    }
    if (booking.is_kiosk && booking?.payment_link_id?.status === "paid") {
      const pl = booking?.payment_link_id;
      const isStripeLink =
        pl?.isStripe === true || pl?.payment_gateway === "Stripe";
      let payment_intent = isStripeLink
        ? pl?.stripe_payment_link_id
        : pl?.payment_intent;
      options.push({ value: payment_intent, label: `payment link price-${fullTripPrice} || refunded price-${booking.price_details.refunded_price}`, data: { trip: "original", price: fullTripPrice, refundedPrice: booking.price_details.refunded_price } })
    }
    dispatch?.(bookingActions.setRefundOptions(options))

    setRefundOptions(options)
  }, [booking, dispatch]);

  return <SelectRedux {...props} options={refundOptions} />;
}
